import axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = process.env.API_URL + '/api'



// WEBPACK FOOTER //
// ./src/config/axios.js